<p-inputgroup>
    <input
        type="number"
        pInputText
        class="pr-2"
        placeholder="0"
        style="text-align: right"
        [attr.data-testid]="dataTestId() ?? 'phx-input-quantity-with-warehouse-input-field'"
        [disabled]="disabled()"
        (ngModelChange)="onValueChange($event)"
        [(ngModel)]="ngModel"
        [ngModelOptions]="{standalone: true}"
        min="1"
    />

    @if (unitIdentifier()) {
        <p-inputgroup-addon data-testid="phx-input-quantity-unit">{{ unitIdentifier() }}</p-inputgroup-addon>
    }
    @if (showWarehouseStockButton()) {
        <p-inputgroup-addon>
            <p-button
                data-testid="phx-input-quantity-with-warehouse-stock-button"
                [disabled]="!quantityInWarehouse()"
                outlined="true"
                severity="secondary"
                (click)="emitQuantityInWarehouse()"
                [ngStyle]="{
                    'background-color': 'rgba(128, 128, 128, 0.15)',
                    'border-color': 'rgba(0, 0, 0, 0.15)'
                }"
            >
                {{ '/ ' + (isLoading() ? '' : quantityInWarehouse() ?? '??') }}
                @if (isLoading()) {
                    <span
                        class="fa fa-spinner animate-spin"
                        data-testid="phx-input-quantity-with-warehouse-stock-button-spinner"
                    ></span>
                }
            </p-button>
        </p-inputgroup-addon>
    }
</p-inputgroup>
